import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../App.css';

const API_URL = (process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : '')) + '/api';

function Appointments() {
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [drivingSchools, setDrivingSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Fetch driving schools on component load
  useEffect(() => {
    const fetchDrivingSchools = async () => {
      try {
        const response = await axios.get(`${API_URL}/rijscholen`);
        setDrivingSchools(response.data);
      } catch (error) {
        console.error('Error fetching driving schools:', error);
      }
    };
    fetchDrivingSchools();
  }, []);

  // Fetch appointments only when school and date are selected
  useEffect(() => {
    if (selectedSchool && selectedDate) {
      fetchAppointmentsForDate(selectedDate, selectedSchool);
    } else {
      setAppointments([]);
    }
  }, [selectedDate, selectedSchool]);

  const fetchAppointmentsForDate = async (date, schoolName) => {
    setIsLoading(true);
    try {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      
      const url = `${API_URL}/appointments/${formattedDate}?rijschool=${encodeURIComponent(schoolName)}`;

      const response = await axios.get(url);
      setAppointments(response.data);
      setMessage({ text: '', type: '' });
    } catch (error) {
      console.error('Error fetching appointments:', error);
      setMessage({ text: 'Fout bij ophalen afspraken.', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSchoolChange = (e) => {
    setSelectedSchool(e.target.value);
  };

  return (
    <div className="main-content-wrapper fade-in-up" style={{ maxWidth: '1200px', marginTop: '40px' }}>
      <div className="top-left-fixed" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <button onClick={() => navigate('/')} className="action-button-blue">Home</button>
        <button onClick={() => navigate(-1)} className="action-button-blue">Terug</button>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h1 className="aharoni-style" style={{ fontSize: '2.5em', marginBottom: '5px' }}>
          Afspraken Bekijken
        </h1>
        <div style={{ maxWidth: '300px', margin: '20px auto' }}>
          <label className="form-label">Selecteer Rijschool:</label>
          <select 
            className="form-select" 
            value={selectedSchool} 
            onChange={handleSchoolChange}
          >
            <option value="">-- Kies een rijschool --</option>
            {drivingSchools.map((school, index) => (
              <option key={index} value={school.rijschool_naam}>
                {school.rijschool_naam}
              </option>
            ))}
          </select>
        </div>
      </div>

      {message.text && (
        <div className={`message-box ${message.type}`} style={{ 
          padding: '15px', 
          borderRadius: '8px', 
          marginBottom: '20px', 
          width: '100%',
          maxWidth: '800px',
          backgroundColor: message.type === 'success' ? '#28a74522' : '#dc354522',
          border: `1px solid ${message.type === 'success' ? '#28a745' : '#dc3545'}`,
          color: 'white'
        }}>
          {message.text}
        </div>
      )}

      <div className="admin-grid" style={{ width: '100%', alignItems: 'start' }}>
        <div className="admin-card" style={{ padding: '20px', height: 'fit-content' }}>
          <h3 style={{ marginBottom: '20px', fontSize: '1.5em' }}>Selecteer Datum</h3>
          <div className="admincalender">
            <Calendar
              onChange={handleDateChange}
              value={selectedDate}
              locale="nl-NL"
            />
          </div>
        </div>

        <div className="admin-card" style={{ textAlign: 'left', alignItems: 'stretch', padding: '30px' }}>
          <h2 style={{ marginBottom: '25px', color: '#007bff', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
            Afspraken op {selectedDate.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })}
          </h2>
          
          {!selectedSchool ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#888' }}>
              <p style={{ fontSize: '1.1em' }}>Selecteer eerst een rijschool om de afspraken te bekijken.</p>
            </div>
          ) : isLoading ? (
            <p>Laden...</p>
          ) : appointments.length > 0 ? (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {appointments.map((appointment) => (
                <li key={appointment.id} className="fade-in-up" style={{ 
                  backgroundColor: '#1e1e1e', 
                  border: '1px solid #333',
                  borderRadius: '10px',
                  padding: '20px',
                  marginBottom: '15px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ flex: '1', minWidth: '200px' }}>
                    <p style={{ fontSize: '1.25em', margin: '0 0 5px 0', color: '#fff' }}><strong>{appointment.leerling || 'Onbekend'}</strong></p>
                    <p style={{ color: '#aaa', margin: '0', fontSize: '1.1em' }}>Tijd: <span style={{ color: '#007bff', fontWeight: 'bold' }}>{appointment.tijd || 'Onbekend'}</span></p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
              <p style={{ fontSize: '1.2em', fontStyle: 'italic' }}>Geen afspraken gevonden voor deze rijschool op deze datum.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Appointments;
